export default "__VITE_ASSET__jeI33HJz__"